<template>
  <!-- 处理工单弹窗 -->
  <dialog-solve
    v-if="solveDialogVisible"
    :mode="1"
    :order-id="currentOrderId"
    :info="currentInfo"
    :priority-list="priorityList"
    @refresh="refreshList"
    @close="solveDialogVisible = false"
  ></dialog-solve>
  <div v-else class="machine-group">
    <div class="el-search vue-top-padding radius">
      <div class="el-right">
        <el-form
          :model="search"
          :inline="true"
          label-width="10px"
          size="small"
          class="demo-form-inline el-input-height"
        >
          <el-form-item prop="orderNo" style="margin-bottom: 0">
            <el-input v-model="search.orderNo" :placeholder="$t('upgrade.WorkOrder.279301-1')"></el-input>
          </el-form-item>
          <el-form-item prop="equipmentNo" style="margin-bottom: 0">
            <el-input v-model="search.equipmentNo" :placeholder="$t('upgrade.WorkOrder.279301-2')"></el-input>
          </el-form-item>
          <el-form-item prop="equipmentName" style="margin-bottom: 0">
            <el-input v-model="search.equipmentName" :placeholder="$t('upgrade.WorkOrder.279301-3')"></el-input>
          </el-form-item>
          <el-form-item prop="handleStatus" style="margin-bottom: 0">
            <el-select v-model="search.handleStatus" :placeholder="$t('upgrade.WorkOrder.279301-4')">
              <el-option
                v-for="item in handleStatusList"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="reportStatus" style="margin-bottom: 0">
            <el-select v-model="search.reportStatus" :placeholder="$t('upgrade.WorkOrder.279301-5')" clearable>
              <el-option
                v-for="item in reportStatusList"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="priority" style="margin-bottom: 0">
            <el-select v-model="search.priority" :placeholder="$t('upgrade.WorkOrder.279301-6')" clearable>
              <el-option
                v-for="item in priorityList"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item style="margin: 0">
            <el-button type="primary" @click="onSubmit" icon="el-icon-search">{{
              $t("upgrade.WorkOrder.279301-7")
            }}</el-button>
            <el-button @click="resetSearch()" icon="el-icon-refresh">{{ $t("upgrade.WorkOrder.279301-8") }}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="vue-padding">
      <el-table
        v-loading="loading"
        :empty-text="$t('upgrade.WorkOrder.279301-9')"
        :element-loading-text="$t('upgrade.WorkOrder.279301-10')"
        :data="tableList"
        style="width: 100%"
        max-height="638"
        :border="true"
        @sort-change="handleSortChange"
      >
        <el-table-column
          prop="orderNo"
          :show-overflow-tooltip="true"
          :label="$t('upgrade.WorkOrder.279301-1')"
          :align="'center'"
          min-width="180"
        ></el-table-column>
        <el-table-column
          prop="equipmentNo"
          :show-overflow-tooltip="true"
          :label="$t('upgrade.WorkOrder.279301-2')"
          :align="'center'"
          min-width="160"
        ></el-table-column>
        <el-table-column
          prop="equipmentName"
          :show-overflow-tooltip="true"
          :label="$t('upgrade.WorkOrder.279301-11')"
          :align="'center'"
          min-width="160"
        ></el-table-column>
        <el-table-column
          prop="userName"
          :show-overflow-tooltip="true"
          :label="$t('upgrade.WorkOrder.279301-12')"
          :align="'center'"
          min-width="160"
        ></el-table-column>
        <el-table-column
          prop="equipmentTypeName"
          :show-overflow-tooltip="true"
          :label="$t('upgrade.WorkOrder.279301-13')"
          :align="'center'"
          min-width="160"
        ></el-table-column>
        <el-table-column
          prop="user"
          min-width="120"
          :show-overflow-tooltip="true"
          :label="$t('upgrade.WorkOrder.279301-14')"
          :align="'center'"
        ></el-table-column>
        <el-table-column
          prop="description"
          min-width="160"
          :show-overflow-tooltip="true"
          :label="$t('upgrade.WorkOrder.279301-15')"
          :align="'center'"
        ></el-table-column>
        <el-table-column
          prop="createTime"
          :show-overflow-tooltip="true"
          :label="$t('upgrade.WorkOrder.279301-16')"
          :align="'center'"
          min-width="160"
          sortable="custom"
        ></el-table-column>
        <el-table-column
          prop="rating"
          :show-overflow-tooltip="true"
          :label="$t('upgrade.WorkOrder.279301-17')"
          :align="'center'"
          min-width="160"
          sortable="custom"
        >
          <template #default="scope">
            <span v-if="scope.row.rating === null">-</span>
            <el-rate v-else v-model="scope.row.rating" disabled></el-rate>
          </template>
        </el-table-column>
        <el-table-column
          prop="priority"
          min-width="120"
          :show-overflow-tooltip="true"
          :label="$t('upgrade.WorkOrder.279301-18')"
          :align="'center'"
          sortable="custom"
        >
          <template slot-scope="scope">
            <span :style="{ color: priorityList.find(item => item.value === scope.row.priority)?.color }">
              {{ priorityList.find(item => item.value === scope.row.priority)?.label || "-" }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="reportStatus"
          min-width="120"
          :show-overflow-tooltip="true"
          :label="$t('upgrade.WorkOrder.279301-19')"
          :align="'center'"
        >
          <template slot-scope="scope">
            <span :style="{ color: reportStatusList.find(item => item.value === scope.row.reportStatus)?.color }">
              {{ reportStatusList.find(item => item.value === scope.row.reportStatus)?.label || "-" }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="handleStatus"
          min-width="120"
          :show-overflow-tooltip="true"
          :label="$t('upgrade.WorkOrder.279301-20')"
          :align="'center'"
        >
          <template slot-scope="scope">
            <span :style="{ color: handleStatusList.find(item => item.value === scope.row.handleStatus)?.color }">
              {{ handleStatusList.find(item => item.value === scope.row.handleStatus)?.label || "-" }}
            </span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('upgrade.WorkOrder.279301-21')" :align="'center'" fixed="right" width="120">
          <template slot-scope="scope">
            <el-button style="margin: 3px" size="mini" type="primary" @click="handleWorkOrder(scope.row)">
              {{ $t("upgrade.WorkOrder.279301-22") }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="tableList.length > 0"
        background
        layout="prev, pager, next"
        :current-page="page.pageIndex"
        :total="page.totalSize"
        :page-size="page.pageSize"
        @current-change="currentChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
  import DialogSolve from "./components/DialogSolve.vue";

  export default {
    name: "WorkOrder",
    components: {
      DialogSolve
    },
    data() {
      return {
        search: {},
        loading: false,
        tableList: [],
        page: {
          pageSize: 10,
          pageIndex: 1
        },
        sortParams: {
          sort: "",
          order: ""
        },
        questionTypeMap: {
          1: this.$t("upgrade.WorkOrder.279301-23"),
          2: this.$t("upgrade.WorkOrder.279301-24"),
          3: this.$t("upgrade.WorkOrder.279301-25")
        },
        priorityList: [
          { label: this.$t("upgrade.WorkOrder.279301-26"), value: 0, color: "#21CD66" },
          { label: this.$t("upgrade.WorkOrder.279301-27"), value: 1, color: "#FDD22A" },
          { label: this.$t("upgrade.WorkOrder.279301-28"), value: 2, color: "#FF4444" },
          { label: this.$t("upgrade.WorkOrder.279301-29"), value: 3, color: "#FF4444" }
        ],
        solveDialogVisible: false,
        currentOrderId: "",
        handleStatusList: [
          { label: this.$t("upgrade.WorkOrder.279301-30"), value: 0, color: "#FF4444" },
          { label: this.$t("upgrade.WorkOrder.279301-31"), value: 2, color: "#21CD66" },
          { label: this.$t("upgrade.WorkOrder.279301-32"), value: -1, color: "#A3A3A3" }
        ],
        reportStatusList: [
          { label: this.$t("upgrade.WorkOrder.279301-33"), value: 0, color: "#FF4444" },
          { label: this.$t("upgrade.WorkOrder.279301-34"), value: 1, color: "#21CD66" },
          { label: this.$t("upgrade.WorkOrder.279301-35"), value: 2, color: "#A3A3A3" }
        ],
        saveLoading: false
      };
    },
    async mounted() {
      this.handlerSetDefaultHandleStatus();
      this.currentChange();
    },
    methods: {
      handlerSetDefaultHandleStatus() {
        let num = 0;
        if (localStorage.getItem("handleStatus")) {
          num = +localStorage.getItem("handleStatus");
        }
        this.$set(this.search, "handleStatus", num);
      },
      handlerEdit() {
        this.saveLoading = true;
        this.$api.request(this.$url.WorkOrder.edit, this.$method.post, this.currentInfo).then(res => {
          if (res.code === 0) {
            this.$message.success(this.$t("upgrade.WorkOrder.240966-0"));
          } else {
            this.$message.error(res.msg);
          }
          this.saveLoading = false;
        });
      },
      // 刷新工单列表
      refreshList() {
        this.currentChange();
      },
      currentChange(pageIndex) {
        this.loading = true;
        this.page.pageIndex = pageIndex ? pageIndex : this.page.pageIndex;

        // 使用JavaScript原生方法合并对象
        let obj = { ...this.search, ...this.page };

        // 添加排序参数
        if (this.sortParams.sort) {
          obj.sort = this.sortParams.sort;
          obj.order = this.sortParams.order;
        }

        // 输出请求参数到控制台
        console.log(this.$t("upgrade.WorkOrder.279301-36"), obj);

        //状态存入缓存
        localStorage.setItem("handleStatus", this.search.handleStatus);

        this.$api
          .request(this.$url.WorkOrder.page, this.$method.get, { type: 1, ...obj })
          .then(res => {
            if (res.code === 0) {
              this.tableList = res.data.records;
              this.page.totalSize = parseInt(res.data.total);
            }
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      },
      // 搜索
      onSubmit() {
        this.currentChange();
      },
      // 重置搜索
      resetSearch() {
        this.searchTime = null;
        Object.keys(this.search).map(key => {
          if (key === "handleStatus") return;
          this.search[key] = null;
        });
        this.currentChange();
      },
      // 获取问题类型名称
      getQuestionTypeName(type) {
        return this.questionTypeMap[type] || this.$t("upgrade.WorkOrder.279301-37");
      },
      // 获取优先级名称
      getPriorityName(priority) {
        return this.priorityMap[priority] || this.$t("upgrade.WorkOrder.279301-38");
      },
      // 处理工单
      handleWorkOrder(row) {
        this.currentOrderId = row.id;
        this.solveDialogVisible = true;
      },

      // 处理排序变化
      handleSortChange({ prop, order }) {
        console.log(this.$t("upgrade.WorkOrder.279301-39"), prop, order);
        if (order) {
          // 排序方向转换
          const sortOrder = order === "ascending" ? "asc" : "desc";
          // 确保使用正确的参数名称
          this.sortParams.sort = prop;
          this.sortParams.order = sortOrder;
        } else {
          // 取消排序
          this.sortParams.sort = "";
          this.sortParams.order = "";
        }
        console.log(this.$t("upgrade.WorkOrder.279301-40"), this.sortParams);
        // 重新加载数据
        this.currentChange();
      }
    }
  };
</script>

<style scoped>
  .el-left {
    float: left;
    margin-right: 15px;
  }
</style>
